<template>
	<div id="banner">
		<div class="b_banxin">
			<div class="v_listbox flex">
				<div class="v_listboxleft">
					<div class='v_listboxlefttop_box'>
						<div class="v_listboxlefttop flex">
							<div :class="{v_active:vactive==1}" @click="newShopFn1">疯狂抢购</div>
							<div :class="{v_active:vactive==2}" @click="newShopFn2()">猜你喜欢</div>
							<div :class="{v_active:vactive==3}" @click="newShopFn()">新品首发</div>
						</div>
						<div class="v_listboxlefttop1" @click="jumpNew" v-if="vactive==3">
							更多>>
						</div>
						<div class="v_listboxlefttop1" v-else>
							<!--更多>>-->
						</div>
					</div>
					
					<div class="v_listboxleftbtn flex" v-show="vactive==1">
						<router-link :to="{path:'/huodongdetails', query:{ goods_id:item.id,panic_id:item.panic_id,type:2}}" target="_blank" class="v_listboxleftbtnson" v-for="(item,index) in shoplist1" :key="index" v-if="index < 4">
							<img :src="imgurl+item.skus[0].image" alt class="v_shopimg" />
							<div class="txtnowarp2 v_shoptxt">{{item.title}}</div>
							<div class="kucun">库存：{{Number(item.total) - Number(item.occupy)}}</div>
							<div class="v_shopbtn flex">
								<div class="v_shopbtnleft txtnowarp">抢购价</div>
								<div class="v_shopbtnright txtnowarp">
									<span>￥</span> {{item.skus[0].panic_price}}
								</div>
							</div>
							<img class="qianggoubiao" src="../../../../public/img/qianggou.png" />
						</router-link>
					</div>
					<div class="v_listboxleftbtn flex" v-show="vactive==2">
						<router-link :to="{path:'/details', query:{ goods_id:item.id }}" target="_blank" class="v_listboxleftbtnson" v-for="(item,index) in shoplist2" :key="index">
							<img :src="imgurl+item.skus[0].image" alt class="v_shopimg" />
							<div class="txtnowarp2 v_shoptxt">{{item.title}}</div>
							<div class="kucun">库存：{{Number(item.skus[0].stock) + Number(item.skus[0].virtual_inventory) - Number(item.skus[0].virtual_occupy)}}</div>
							<div class="v_shopbtn flex">
								<div class="v_shopbtnleft txtnowarp">抢购价</div>
								<div class="v_shopbtnright txtnowarp">
									<span>￥</span> {{item.skus[0].shop_price}}
								</div>
							</div>
							<img class="qianggoubiao" v-if="item.recomm_type == 1" src="../../../../public/img/tejia.png"/>
							<img class="qianggoubiao" v-if="item.recomm_type == 3" src="../../../../public/img/xinpin.png"/>
							<img class="qianggoubiao" v-if="item.recomm_type == 4" src="../../../../public/img/tuijian.png"/>
						</router-link>
					</div>
					<div class="v_listboxleftbtn flex" v-show="vactive==3">
						<router-link :to="{path:'/details', query:{ goods_id:item.id }}" target="_blank" class="v_listboxleftbtnson" v-for="(item,index) in shoplist3" :key="index">
							<img :src="imgurl+item.skus[0].image" alt class="v_shopimg" />
							<div class="txtnowarp2 v_shoptxt">{{item.title}}</div>
							<div class="kucun_item">
								<div class="kucun_left">库存：{{Number(item.skus[0].stock) + Number(item.skus[0].virtual_inventory) - Number(item.skus[0].virtual_occupy)}}</div>
								<div class="v_shopbtn_q">
									<em>￥</em> {{item.skus[0].shop_price}}
								</div>
							</div>
							<img class="qianggoubiao" src="../../../../public/img/xinpin.png" />
						</router-link>
					</div>
				</div>
				<div class="v_listboxright">
					<swiper :options="swiperOption" v-if="rightbannr.length">
						<swiper-slide class="swiper-slide" v-for="(item,index) in rightbannr" :key="index">
							<a :href="item.url">
								<img :src="imgurl+item.banner_img" class="v_bannersize" />
							</a>
						</swiper-slide>
						<div class="swiper-pagination" slot="pagination" id="splt"></div>
					</swiper>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import qs from "qs";

	export default {
		data() {
			return {
				newShop: {},
				imgurl: "",
				//广告banner
				swiperOption: {
					//显示分页
					pagination: {
						el: ".swiper-pagination"
					},
					//设置点击箭头
					navigation: {
						nextEl: ".swiper-button-next",
						prevEl: ".swiper-button-prev"
					},
					observer: true, //修改swiper自己或子元素时，自动初始化swiper
					observeParents: true, //修改swiper的父元素时，自动初始化swipe
					//自动轮播
					autoplay: {
						delay: 3000,
						disableOnInteraction: false
					},
					//开启循环模式
					loop: true
				},
				//banner数据
				rightbannr: [

				],
				//默认选中
				vactive: 1,
				//疯狂抢购
				shoplist1: [],
				//猜你喜欢
				shoplist2: [],
				//新品首发
				shoplist3: [],
				newShop1: {}, //疯狂抢购
				newXihuan: {}, //猜你喜欢
			};
		},
		created() {
			let that = this;
			that.Panicbuyingbanner();
			console.log(that.$storage.get("user_data"))
			that.imgurl = that.$publicUrl.http1;
			if(that.$storage.get("user_data") != null) {
				that.newShop["userrole"] = that.$storage.get("user_data").rank_id;
				that.newShop["user"] = that.$storage.get("user_data").user_id;
				that.newShop1["userrole"] = that.$storage.get("user_data").rank_id;
				that.newXihuan["userrole"] = that.$storage.get("user_data").rank_id;
				that.newXihuan["user"] = that.$storage.get("user_data").user_id;
			} else {

				that.newShop["userrole"] = 1;
				that.newShop1["userrole"] = 1;
				that.newXihuan["user"] = 0;
				that.newXihuan["userrole"] = 1;
			}
			that.newShopFn1();
		},
		methods: {
			newShopFn() {
				let that = this;
				that.vactive = 3;
				that.newShop["recomm_type"] = "3";
				that.newShop["page_number"] = "4";
				axios({
						method: "post",
						headers: {
							"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
						},
						url: that.$publicUrl.http1 + that.$publicUrl.goodssearch,
						data: qs.stringify(that.newShop)
					})
					.then(function(response) {
						let data = response.data;
						if(data.stateCode == 10000) {
							let arrshop = data.data.data;
							console.log(arrshop)
							that.shoplist3 = arrshop;
						} else {
							//          that.$message({
							//            message: data.msg,
							//            type: "warning"
							//          });
						}
					})
					.catch(function(error) {});
			},
			newShopFn1() {
				let that = this;
				that.vactive = 1;

				axios({
						method: "post",
						headers: {
							"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
						},
						url: that.$publicUrl.http1 + that.$publicUrl.promotionspanic_buyingget,
						data: qs.stringify(that.newShop1)
					})
					.then(function(response) {
						let data = response.data;
						if(data.stateCode == 10000) {
							let arrshop = data.data.goods;
							console.log(arrshop);
							for(let i in arrshop) {
								arrshop[i].panic_id = data.data.id;
							}

							that.shoplist1 = arrshop;

						} else {
							//          that.$message({
							//            message: data.msg,
							//            type: "warning"
							//          });
						}
					})
					.catch(function(error) {});
			},
			newShopFn2() {
				let that = this;
				that.vactive = 2;
				that.newXihuan['number'] = 4;
				axios({
						method: "post",
						headers: {
							"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
						},
						url: that.$publicUrl.http1 + that.$publicUrl.goodsmaylike,
						data: qs.stringify(that.newXihuan)
					})
					.then(function(response) {
						let data = response.data;
						if(data.stateCode == 10000) {
							let arrshop = data.data.data;

							that.shoplist2 = arrshop;

						} else {
							//          that.$message({
							//            message: data.msg,
							//            type: "warning"
							//          });
						}
					})
					.catch(function(error) {});
			},
			jumpNew() {
				let that = this;
				that.$router.push({
					path: "/newlist",
					query: {
						
					}	
				});
			},
			Panicbuyingbanner() {
				let that = this;
				axios({
						method: "post",
						headers: {
							"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
						},
						url: that.$publicUrl.http1 + that.$publicUrl.Panicbuyingbanner,
						data: qs.stringify({
							type: "5"
						})
					})
					.then(function(response) {
						let data = response.data;
						if(data.stateCode == 10000) {
							let arrshop = data.data;
							that.rightbannr = [];
							that.rightbannr = arrshop;
						} else {
							that.$message({
								message: data.msg,
								type: "warning"
							});
						}
					})
					.catch(function(error) {});
			}
		}
	};
</script>
<style scoped>
	#indexinner {
		background-color: #f6f6f6;
	}
	
	.v_listbox {
		box-sizing: border-box;
		/* padding: 0 10px; */
		width: 100%;
		min-height: 400px;
		background-color: #ffffff;
		margin-top: 20px;
		padding-left: 15px;
	}
	
	.v_listboxleft {
		width: 930px;
		height: 448px;
	}
	.v_listboxlefttop_box{
		width: 100%;
		display: flex;
		flex-wrap: nowrap;
		justify-content: space-between;
		border-bottom: 2px solid #dc1e33;
		box-sizing: border-box;
	}
	.v_listboxlefttop {
		width: 90%;
		height: 70px;
		
		box-sizing: border-box;
	}
	.v_listboxlefttop1 {
		width: 10%;
		height: 70px;
		text-align: right;
		line-height: 70px;
		font-size: 20px;
		cursor: pointer;
		/*border-bottom: 2px solid #dc1e33;*/
		
	}
	.v_listboxlefttop div {
		padding: 0 25px;
		height: 70px;
		line-height: 70px;
		font-size: 20px;
		position: relative;
	}
	
	.v_listboxleftbtnson:hover {
		transition: all 0.2s linear;
		-webkit-box-shadow: 0 1px 6px #dc1e33;
		box-shadow: 0 1px 6px #dc1e33;
	}
	
	.v_listboxleftbtn {
		width: 100%;
		height: 375px;
		overflow: hidden;
		box-sizing: border-box;
		padding: 10px 0;
	}
	
	.v_listboxleftbtnson {
		display: inline-block;
		width: 220px;
		height: 355px;
		box-sizing: border-box;
		margin: 1px;
		margin-right: 15px;
		-webkit-box-shadow: 0 1px 6px #ccc;
		box-shadow: 0 1px 6px #ccc;
		position: relative;
	}
	
	.qianggoubiao {
		display: inline-block;
		position: absolute;
		right: 0;
		top: 0;
		width: 64px;
	}
	
	.v_shopimg {
		width: 100%;
		height: 225px;
		display: block;
	}
	
	.v_shoptxt {
		height: 50px;
		line-height: 25px;
		font-size: 14px;
		width: 100%;
		padding: 0 10px;
		box-sizing: border-box;
		margin: 10px 0;
	}
	
	.v_shopbtn {
		width: 100%;
		height: 40px;
		/*margin: 10px 0;*/
		padding: 0 10px;
		box-sizing: border-box;
	}
	
	.kucun_item {
		width: 100%;
		padding: 0 10px;
		box-sizing: border-box;
		display: flex;
		flex-wrap: nowrap;
		justify-content: space-between;
	}
	
	.v_shopbtn_q {
		/*width: 100%;*/
		height: 40px;
		/*margin: 10px 0;*/
		padding: 0 10px;
		box-sizing: border-box;
		font-size: 16px;
		color: #dc1e33;
		line-height: 40px;
	}
	
	.kucun_left {
		height: 40px;
		/*margin: 10px 0;*/
		/*padding: 0 10px;*/
		box-sizing: border-box;
		font-size: 14px;
		color: #666666;
		line-height: 40px;
	}
	
	.kucun {
		color: #666666;
		font-size: 14px;
		padding: 0 10px;
		box-sizing: border-box;
		height: 20px;
		line-height: 20px;
	}
	
	.v_shopbtnleft {
		width: 40%;
		height: 40px;
		line-height: 40px;
		font-size: 14px;
		color: #dc1e33;
	}
	
	.v_shopbtnright {
		width: calc(100% - 40%);
		text-align: right;
		color: #dc1e33;
		font-size: 18px;
		height: 40px;
		line-height: 40px;
	}
	
	.v_shopbtnright span {
		font-size: 14px;
		height: 40px;
		display: inline-block;
		line-height: 40px;
	}
	
	.v_active {
		color: #dc1e33;
	}
	
	.v_active:after {
		content: " ";
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translateX(-50%);
		width: 24px;
		background-color: #dc1e33;
		height: 12px;
		clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
	}
	
	.v_listboxright {
		width: 220px;
		height: 355px;
		-webkit-box-shadow: 0 1px 6px #ccc;
		box-shadow: 0 1px 6px #ccc;
		margin-top: 80px;
		margin-left: 15px;
	}
	
	.v_bannersize {
		display: block;
		width: 220px;
		height: 355px;
		object-fit: scale-down;
	}
	
	.v_listboxright:hover {
		transition: all 0.2s linear;
		-webkit-box-shadow: 0 1px 6px #dc1e33;
		box-shadow: 0 1px 6px #dc1e33;
	}
	
	#splt .swiper-pagination-bullet-active {
		opacity: 1;
		background: #dc1e33 !important;
	}
	
	.txtcenter {
		text-align: center;
		color: #dc1e33;
		font-size: 18px;
		height: 40px;
		line-height: 40px;
	}
	
	.txtcenter em {
		color: #dc1e33;
		font-size: 14px;
		font-style: initial;
	}
</style>